if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
    const wrapper = document.getElementById(`drop-buy-buttons-${sectionId}`);
    if (!wrapper) return;

    const notifyMe = wrapper.querySelector('.product-form__drop-notify-me');
    const inStock = wrapper.querySelector('.product-form__in-stock-treatment');
    if (!notifyMe || !inStock) return;

    const isOos = !variant || variant.available === false;
    notifyMe.hidden = !isOos;
    inStock.hidden = isOos;
  });
}
